import { TransactionResponse, TransactionRequestBody } from 'models/Transaction'
import { api } from '../api'

export const transactionsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    createTransaction: builder.mutation<
      TransactionResponse,
      { campaignId: string; transaction: TransactionRequestBody }
    >({
      query: ({ campaignId, transaction }) => ({
        method: 'POST',
        url: `campaigns/${campaignId}/transactions`,
        body: transaction,
      }),
    }),
  }),
})

export default transactionsApi
